import React from "react";
import { Persona } from "@fluentui/react-components";
import "./PersonComponent.css";


const GenericPersona = (props) => {
  const mapAvailabilityToPersonaPresence = (availability) => {
    switch (availability) {
      case "Available":
        return "available";
      case "AvailableIdle":
        return "available-idle";
        case "InAMeeting":
        return "in-a-meeting";
      case "Busy":
        return "busy";
      case "Away":
        return "away";
      case "BeRightBack":
        return "away";
      case "AppearAway":
        return "appear-away";
      case "DoNotDisturb":
        return "do-not-disturb";
      case "Offline":
        return "offline";
      case "AppearOffline":
        return "appear-offline";
      case "OffWork":
        return "off-work";
      case "OutOfOffice":
        return "out-of-office";
      case "Inactive":
        return "inactive";
      case "PresenceUnknown":
        return "presence-unknown";
      case "Blocked":
        return "blocked";
      default:
        return "unknown";
    }
  };
  
  const presence = mapAvailabilityToPersonaPresence(props.availability);
 
  return (
    <Persona
    size="small"
    textAlignment="center"
      name={props.name}
      secondaryText={props.secondaryText}
     
      avatar={
    props.avatar?.image?.src
      ? {
          image: {
            src: props.avatar.image.src, 
          },
        }
      : {
          color: "colorful", 
        }
  }
    />
  );
};

export default GenericPersona;
